import React, { forwardRef, memo } from 'react'

const ArcPlusIcon = forwardRef<SVGSVGElement, React.SVGProps<SVGSVGElement>>(
  (props, ref) => (
    <svg
      ref={ref}
      width="49.7"
      height="20.3"
      viewBox="0 0 49.7 20.3"
      {...props}>
      <g transform="scale(.7)">
        <path
          d="M25.965 28.046h6.832l-3.397-3.432-3.435 3.432Z"
          fill="#7AB929"
        />
        <path d="m35.444 24.615-.866-.001-.037 3.437 2.329.003.007-.795-1.462-.001.03-2.642Z" />
        <path d="m38.276 26.627 1.214.001.007-.702-1.213-.002.007-.64 1.466.001.006-.671-2.379-.003.005 3.432 2.387.001.006-.671-1.515-.001.007-.746Z" />
        <path d="M42.401 26.574s.913-.425.646-1.277c0 0-.193-.639-.988-.668l-1.763.007-.006 3.436h.895l.02-1.874 1.106 1.88h.887s-.716-1.445-.777-1.487zm-.669-.412c-.497 0-.549-.014-.549-.014s.009-.799.009-.827.551.008.643.008c.038 0 .343.06.339.37 0 0 .055.465-.442.465z" />
        <path d="M45.229 24.539c-.804 0-1.803.595-1.816 1.76-.014 1.279.973 1.783 1.777 1.784 1.185 0 1.728-.977 1.737-1.782.011-.986-.894-1.762-1.698-1.762m-.067 2.834c-.533 0-.791-.398-.783-1.161.006-.64.351-.951.804-.951.312 0 .771.178.763.952-.009.884-.254 1.16-.784 1.16Z" />
        <path d="m49.026 24.62-.68 1.221-.57-1.222h-.951l1.043 2.009.006 1.436.88.002.015-1.358 1.265-2.085-1.009-.003Z" />
        <path d="m54.214 24.615-.671 1.845-.629-1.846h-1.136l.035 3.443h.794l.012-1.824.692 1.826.519-.001.656-1.817.018 1.817.838.001-.035-3.445-1.093.002Z" />
        <path d="m57.131 27.347-.008-.752h1.186l-.008-.724h-1.193l-.006-.561h1.512l-.006-.695-2.414-.001.033 3.445h2.408l-.006-.711h-1.498Z" />
        <path d="M62.29 25.566s0-.81-.791-.951h-2.11l.027 3.443h.895l-.02-1.882 1.233 1.882h.916s-.768-1.462-.804-1.52c0 0 .602-.177.651-.973zm-1.372.56-.625-.014s-.008-.732-.008-.824h.639c.07 0 .46-.056.451.469 0 0-.067.369-.457.37Z" />
        <path d="m63.99 27.22-.026-2.606-.895.001.034 3.443h2.365l-.009-.838H63.99Z" />
        <path d="M66.058 24.615 66.093 28.058h.873l-.033-3.443h-.875Z" />
        <path d="m71 28.059-.035-3.444h-.795l.022 2.279-1.309-2.28-1.185.002.033 3.443h.818l-.045-2.309 1.458 2.309H71Z" />
        <path d="m32.171 13.95 4.464 5.713h1.797l-4.464-5.713h-1.797Z" />
        <path d="M9.873.725H8.741L0 19.471h1.669L9.511 2.652l4.689 10.057H8.417l-.719 1.541h7.221l2.434 5.221h1.669L10.282.725h-.409Z" />
        <path d="M37.949 6.182C37.949 3.543 36.211.725 31.333.725h-6.709l-.454 1.086v17.659h1.541v-7.832h6.709c4.878 0 6.616-2.818 6.616-5.456m-13.325 3.916V2.266h6.708c3.225 0 5.075 1.428 5.075 3.916 0 2.488-1.85 3.916-5.075 3.916h-6.708Z" />
        <path d="M57.516 14.927c-1.467 1.924-3.782 3.168-6.382 3.168-4.424 0-8.025-3.6-8.025-8.024 0-4.425 3.601-8.025 8.025-8.025 2.601 0 4.916 1.244 6.382 3.169l1.225-.932C56.992 1.99 54.233.505 51.132.505 45.858.505 41.567 4.796 41.567 10.07c0 5.274 4.291 9.566 9.565 9.566 3.101 0 5.86-1.484 7.609-3.777l-1.225-.932Z" />
        <path
          d="M70.995 9.3h-5.563V3.737h-1.54V9.3h-5.564v1.541h5.564v5.563h1.54V10.841h5.563V9.3Z"
          fill="#7AB929"
        />
      </g>
    </svg>
  )
)

ArcPlusIcon.displayName = 'ArcPlusIcon'

export default memo(ArcPlusIcon)
